'use strict';
import { react2angular } from 'react2angular';
import InvoiceHistoryWrapper from "../../src/views/invoice-details/components/invoice-history/InvoiceHistoryWrapper";

angular
    .module('dstreamApp.reactBridge')
    .component('dsInvoiceHistory', react2angular(InvoiceHistoryWrapper, ['invoice', 'isNewInvoice']));
